/**
 * @param {*} number typed phone number
 * @param {*} template Template for Phone Number
 */
export function formatNumber(number, template) {
  const digits = number.replace(/\D/g, "");
  let result = template;
  let digitIndex = 0;

  if (template == undefined || template == null) {
    console.error("Invalid template in formatNumber");
    return digits;
  }

  // Fill the template with available digits
  for (let i = 0; i < result.length; i++) {
    if (result[i] === "_" && digitIndex < digits.length) {
      result =
        result.substring(0, i) + digits[digitIndex] + result.substring(i + 1);
      digitIndex++;
    }
  }

  // Append remaining digits with spaces if there are overflow digits
  if (digitIndex < digits.length) {
    const remainingDigits = digits.slice(digitIndex);
    result += " " + remainingDigits;
  }

  return result;
}

export function extractNumbers(formattedString) {
  return formattedString.replace(/\D/g, "");
}
